import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-label',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './section-label.component.html',
  styleUrl: './section-label.component.scss'
})
export class SectionLabelComponent {
  @Input() mt: string = '0px';
  @Input() mb: string = '0px';
  @Input() size: string = '16px';
  @Input() weight: string = '100';
  @Input() mobileSize?: string;
}
